(function() {
    $(document).ready(function() {
        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);
        oIpss.isWidgetPrefilledWithLastSearchData = true;
        oIpss.prefilledLabelsKeys = {
            'coverageType': 'coverageType',
        };

        oIpss.filterChipLabelMap.offer = {
            'singular': 'Antrag',
            'plural': 'Anträge',
        };

        oIpss.bPriceInCents = true;

        oIpss.periodMap.yearly = 'einmalig';

        oIpss.autoSelectContractTab = true;

        oIpss.tileHeadlineMap.incompleteContract = 'Antrag vervollständigen';
        oIpss.tileHeadlineMap.offer = 'Ihr letzter Antrag';
        oIpss.tileHeadlineMap.contract = 'Ihr letzter Vertrag';

        oIpss.bWholeTileClickable = false;

        oIpss.tilesOrder = [
            'promotions',
            'incompleteContracts',
            'offers',
            'lastSearches',
            'contracts',
        ];

        oIpss.renderHeadline = function(data) {
            if (!oIpss.bUseTilesLayout) { // remove when all ipss are tiles layout
                const self = this;
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);
                const iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                const iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                const iAmountTotal = iAmountNonContracts + iAmountLastSearches;
                let amountHeadlineExtend = '';
                let bContractsOnly = false;
                let amountHeadline;
                let typeHeadline;
                let newHeadline;

                if (!self.isValidApiResponse(data)) {
                    newHeadline = {};

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {

                    newHeadline = {};

                    if (data.contracts && iAmountNonContracts > 0) {

                        if (iAmountLastSearches > 0) {
                            typeHeadline = 'Aktivität';
                        } else {
                            bContractsOnly = true;

                            if (iAmountNonContracts > 1) {
                                typeHeadline = 'Anträge';
                            } else {
                                typeHeadline = 'Antrag';
                            }
                        }

                        if (iAmountTotal < 2) {
                            if (bContractsOnly) {
                                amountHeadline = 'Mein letzter ';
                            } else {
                                amountHeadline = 'Meine letzte ';
                                amountHeadlineExtend = '';
                            }
                        } else {
                            if (bContractsOnly) {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = '';
                            } else {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = 'en';
                            }
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {
                    if (iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline:not(.showEverything)', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }
            } else {
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                const newHeadline = {};
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

                self.iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                self.iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                self.iAmountTotal = self.iAmountNonContracts + self.iAmountLastSearches;

                if (!self.isValidApiResponse(data)) {

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {
                    if (data.contracts && self.iAmountNonContracts > 0) {

                        typeHeadline = 'Aktivität';

                        if (self.iAmountTotal < 2) {
                            amountHeadline = 'Meine letzte ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'en';
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {

                    if (self.iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null && self.aAppointmentsGrouped?.length < 0) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

                if (self.bUseTilesLayout && self.bIsMobile) {
                    $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${self.iAmountTotal})`);
                }
            }
        };

        oIpss.renderDataArrayProductSpecificTileHeadline = function(sRenderType, data) {
            if (sRenderType === 'offer' && data?.completed === false) {
                return 'Antrag vervollständigen';
            }

            return false;
        };

        oIpss.renderProductSpecificLabels = function (data) {
            const labels = { };
            const dataInputs = data.inputs;
            const ageMap = {
                'YoungerThan18': 'ab 15 Jahre',
                'YoungerThan20': 'ab 18 Jahre',
                'YoungerThan23': 'ab 20 Jahre',
                'OlderThan23': 'ab 23 Jahre',
            };
            const priceRangeMap = {
                'UPTO_2500': 'unter 2.500 €',
                'UPTO_5000': '2.501 - 5.000 €',
                'UPTO_7500': '5.001 - 7.500 €',
                'UPTO_10000': '7.501 - 10.000 €',
                'ABOVE_10000': 'über 10.000 €',
            };
            const coverageMap = {
                'haftpflicht': 'Haftpflicht',
                'withTeilkasko': 'Haftpflicht mit Teilkasko',
            };

            if (!data.inputs) {
                return labels;
            }

            if (dataInputs.age) {
                labels.age = ageMap[dataInputs.age] || null;
            } else {
                labels.age = null;
            }

            if (dataInputs.priceRange) {
                labels.priceRange = priceRangeMap[dataInputs.priceRange] || null;
            } else {
                labels.priceRange = null;
            }

            if (dataInputs.coverageType) {
                labels.coverageType = coverageMap[dataInputs.coverageType] || null;
            } else {
                labels.coverageType = null;
            }

            if (dataInputs.vehicleName) {
                labels.vehicleName = dataInputs.vehicleName;
            } else {
                labels.vehicleName = null;
            }

            if (dataInputs.manufacturer) {
                labels.manufacturer = dataInputs.manufacturer;
            } else {
                labels.manufacturer = null;
            }

            return labels;
        };

        oIpss.overrideData = {
            'version': 1,
            'lastUpdate': 1585126706,
            'lastSearches': [
                {
                    'time': 1632756342,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'text': 'Ergebnis anzeigen',
                            'urlDesktop': 'urlDesktop',
                            'urlMobile': 'urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'yearly',
                                'price': 8490,
                            },
                        },
                        'inputs': {
                            'age': 'OlderThan23',
                            'priceRange': 'UPTO_10000',
                            'coverageType': 'haftpflicht',
                            'fittingTariffs': 5,
                            'manufacturer': 'MI ELECTRIC SCOOTER 1S',
                        },
                        'urlDelete': 'urlDelete',
                    },
                },
                {
                    'deviceOutput': 'desktop',
                    'time': 1648054789987,
                    'result': {
                        'cta': {
                            'text': 'Ergebnis anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'yearly',
                                'price': 3553,
                            },
                        },
                        'inputs': {
                            'age': 'YoungerThan18',
                            'priceRange': 'UPTO_2500',
                            'coverageType': 'haftpflicht',
                            'manufacturer': 'NINEBOT MAX G30D (MAX)',
                            'fittingTariffs': 45,
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
            ],
            'contracts': [
                {
                    'time': 1585126706,
                    'type': 'contract',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'cta': [
                        {
                            'type': 'secondary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'urlDesktop',
                            'urlMobile': 'urlMobile',
                            'urlApp': 'urlApp',
                        },
                    ],
                    'tariff': {
                        'name': 'Kompakt',
                        'period': 'yearly',
                        'price': 8490,
                    },
                    'insuranceKey': 'wgv',
                    'status': {
                        'text': 'aktiv seit 01.01.2021',
                        'color': 'green',
                    },
                    'inputs': {
                        'manufacturer': 'ES1010',
                        'coverageType': 'withTeilkasko',
                    },
                    'info': 'Ihr Versicherungsschutz endet bald! Erneuern Sie Ihn jetzt für 29,80 €.',
                },
                {
                    'info': '',
                    'cta': [
                        {
                            'type': 'secondary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1648054808863,
                    'type': 'offer',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'ESC-626800266',
                    'tariff': {
                        'name': 'E-Scooter Haftpflicht',
                        'period': 'yearly',
                        'price': 3553,
                    },
                    'insuranceKey': 'die_bayerische',
                    'inputs': {
                        'manufacturer': 'A',
                        'coverageType': 'haftpflicht',
                    },
                },
                {
                    'info': '',
                    'cta': [
                        {
                            'type': 'secondary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1648054705113,
                    'type': 'offer',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'ESC-626800175',
                    'tariff': {
                        'name': 'E-Scooter Haftpflicht',
                        'period': 'yearly',
                        'price': 2390,
                    },
                    'insuranceKey': 'adam_riese',
                    'inputs': {
                        'coverageType': 'haftpflicht',
                        'manufacturer': 'BT MOBILITY E',
                    },
                },
            ],
            'staticTiles': [
                {
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Vertrag hinzufügen',
                            'urlDesktop': 'primary staticTile URL urlDesktop',
                            'urlMobile': 'primary staticTile URL urlMobile',
                            'urlApp': 'URL',
                            'urlTabletApp': 'URL',
                        },
                    ],
                    'urlDelete': 'https://delete static tile URL',
                },
            ],
            'promotions': [
                {
                    'headline': {
                        'text': 'Saison 2025/2026',
                        'subtext': 'Versicherungsschutz erneuern',
                    },
                    'inputs': {
                        'image': {
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': {
                                'default': 'https://dummyimage.com/242x130/ff0000/fff.jpg',
                                'highRes': 'https://highRes',
                            },
                            'urlApp': 'https://dummyimage.com/242x130/ffa500/000000.jpg',
                            'urlTabletApp': 'https://dummyimage.com/242x130/800080/fff.jpg',
                        },
                        'coverageType': 'withTeilkasko',
                        'manufacturer': 'BT MOBILITY E',
                    },
                    'tariff': {
                        'period': 'yearly',
                        'price': 998,
                    },
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Neues Kennzeichen bestellen',
                            'urlDesktop': 'primary URL urlDesktop',
                            'urlMobile': 'primary URL urlMobile',
                        },
                    ],
                    'urlDelete': 'https://delete promo tile URL',
                },
            ],
        };

        oIpss.bind('esc', 'https://e-scooter-versicherung' + window.c24LpDomain + '/ap-ipss-api/esc/v2', $('.mod24ac.esc'));
    });
})();
